/**
 * 侧边栏组件
 */
import React from 'react';
import { Layout, Menu, Typography, Drawer } from 'antd';
import type { MenuProps } from 'antd';
import { getMenuItems } from './menuConfig';

const { Sider } = Layout;
const { Text } = Typography;

interface SidebarProps {
  collapsed: boolean;
  isMobile: boolean;
  mobileDrawerVisible: boolean;
  selectedKeys: string[];
  openKeys: string[];
  userPermissions?: string[];
  onMenuClick: MenuProps['onClick'];
  onDrawerClose: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  isMobile,
  mobileDrawerVisible,
  selectedKeys,
  openKeys,
  userPermissions,
  onMenuClick,
  onDrawerClose,
}) => {
  const menuItems = getMenuItems(userPermissions);

  const renderMenu = () => (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={selectedKeys}
      defaultOpenKeys={openKeys}
      items={menuItems}
      onClick={onMenuClick}
      style={{ 
        borderRight: 0,
        background: '#0f172a',
      }}
    />
  );

  // 移动端抽屉菜单
  if (isMobile) {
    return (
      <Drawer
        title="菜单"
        placement="left"
        onClose={onDrawerClose}
        open={mobileDrawerVisible}
        width={280}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          selectedKeys={selectedKeys}
          defaultOpenKeys={openKeys}
          items={menuItems}
          onClick={onMenuClick}
          style={{ borderRight: 0 }}
        />
      </Drawer>
    );
  }

  // 桌面端侧边栏
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={220}
      collapsedWidth={80}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: 101,
        background: '#0f172a',
        borderRight: '1px solid #1e293b',
      }}
    >
      <div
        style={{
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderBottom: '1px solid #1e293b',
          background: '#0f172a',
        }}
      >
        <Text
          strong
          style={{
            color: '#ffffff',
            fontSize: collapsed ? 14 : 18,
            whiteSpace: 'nowrap',
            letterSpacing: '0.05em',
          }}
        >
          {collapsed ? '斌宇' : '斌宇林建'}
        </Text>
      </div>
      {renderMenu()}
    </Sider>
  );
};
